<h2 mat-dialog-title>Asignar plan a deportista</h2>
<mat-dialog-content>
    <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
      <input type="hidden" formControlName="usuarioId" value="">


            <mat-form-field appearance="outline" class="example-full-width" style="padding-left: 10px; font-size: smaller;">
                <mat-label>Plan</mat-label>
                <mat-select formControlName="planId">
                  <mat-option *ngFor="let obj of lstPlanes" [value]="obj.id">
                    {{obj.nombre}}
                  </mat-option>
                </mat-select>
        
              </mat-form-field>

      </form>

</mat-dialog-content>
<mat-dialog-actions>
  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button>
    <button mat-button mat-dialog-close='false' >Cancelar</button>
</mat-dialog-actions>
